<!--begin: Quick Actions -->
<div class="kt-header__topbar-item dropdown">
    <div class="kt-header__topbar-wrapper">

    </div>
</div>
<!--end: Quick Actions -->